import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { GlobalToken } from 'antd';

import { useStores } from '@/hooks/use-stores';
import SpinCentered from '@/comp/SpinCentered';

import { EnergySavingsDataBox } from './DataBox.interface';
import { GetDataBox } from './EnergySavingsDataBox';

const EnergySavingsReport = observer(() => {
  const { t } = useTranslation();
  const { stationStore, energySavingsStore } = useStores();
  const { daySavings, monthSavings, yearSavings } = energySavingsStore.energySavings;

  useEffect(() => {
    energySavingsStore.get();
  }, []);

  useEffect(() => {
    energySavingsStore.reset();
    energySavingsStore.get();
  }, [stationStore.currentStation]);

  const dataBoxesData: EnergySavingsDataBox[] = [
    {
      title: t('DAY'),
      percentage: daySavings?.percentageFormatted,
      kwh: daySavings?.energyKwhFormatted,
    },
    {
      title: t('MTD'),
      percentage: monthSavings?.percentageFormatted,
      kwh: monthSavings?.energyKwhFormatted,
      savingsMoney: monthSavings?.savingText,
      savingsCO2: monthSavings?.co2SavingFormatted,
    },
    {
      title: t('YTD'),
      percentage: yearSavings?.percentageFormatted,
      kwh: yearSavings?.energyKwhFormatted,
      savingsMoney: yearSavings?.savingText,
      savingsCO2: yearSavings?.co2SavingFormatted,
    },
  ];

  const getIsReadyOrError = () => {
    if (!energySavingsStore.isReady) return <SpinCentered />;

    if (energySavingsStore.isInErrorState) return <div className="na"> {t('N/A')} </div>;

    return null;
  };

  return (
    <Container>
      <span className="title">{t('ENERGY_SAVINGS')}</span>
      <span className="vertical-line" />
      {getIsReadyOrError() ?? <div className="data-boxes">{dataBoxesData.map(data => GetDataBox(data))}</div>}
    </Container>
  );
});

const Container = styled.div<{ theme: { token: GlobalToken } }>`
  height: 105px;
  display: flex;
  flex-direction: row;
  margin: ${({ theme: { token } }) => token.marginXXL}px;
  flex-shrink: 0;
  align-items: center;
  padding: 0 ${({ theme: { token } }) => token.paddingXL}px 0 ${({ theme: { token } }) => token.paddingXL}px;
  border-radius: 2px;
  background-color: ${({ theme: { token } }) => token.colorBgContainer};
  white-space: nowrap;

  .na {
    color: ${({ theme: { token } }) => token.colorBorder};
    width: 100%;
    text-align: center;
    font-size: ${({ theme: { token } }) => token.fontSizeHeading2}px;
  }

  .data-boxes {
    display: flex;
    flex-direction: row;
  }
  .title {
    text-transform: capitalize;
    font-size: ${({ theme: { token } }) => token.fontSizeXL}px;
  }

  .vertical-line {
    height: 72px;
    width: 1px;
    border-right: 1px solid ${({ theme: { token } }) => token.colorBorder};
s  }
`;

export default EnergySavingsReport;
